const LABELS = {
  FILTER_BASE: 'Filtrar por Nome ou Sigla'
};

export default LABELS;
